import { total_prices } from "@core/gql-mockups/cart";
import { minimize_str } from "@core/helpers/string";

export const CHECK_DISCOUNT_CODE = minimize_str(`
    mutation ($discount_code: String, $shipping_method_id: ID, $address_id: ID, $lang: String = "fa") {
     result: checkDiscount(discount_code: $discount_code, shipping_method_id: $shipping_method_id, address_id: $address_id , is_inquiry: 0, lang: $lang) {
        success
        error_message
        total_prices {
          total_count
          total_price_with_discount
          sum_product_price_without_offer
          payment_price_without_discount
          packaging_price
          packaging_count
          sum_product_price
          post_price
          payment_price
          gift_score
        }
      }
    }
  `);

export const CLOSE_CART = minimize_str(`
  mutation ($input: closeCartInput, $callback_url: String) {
    result: closeCart(input: $input, callback_url: $callback_url) {
      order {
        id
      }
      payment_url
      payment_data
    }
  }
`);

// `payDebt` (the API has no `payDept`: that name answered "Cannot query field", so debt payment failed on every site)
export const PAY_DEBT = minimize_str(`
  mutation ($input: payDebtInput) {
    result: payDebt(input: $input) {
      payment_url
      payment_data
    }
  }
`);


// `chargeWalletInput` is `{ amount: Float, callback_url: String, description: String }` only: there is no
// `payment_gateway_id` (sending one is a 400 BAD_USER_INPUT). The backend picks the wallet's charge gateway itself;
// `payment_gateway_not_found` means none is set up for the site in the panel. Logged-in users only.
export const CHARGE_WALLET = minimize_str(`
  mutation ($input: chargeWalletInput) {
    result: chargeWallet(input: $input) {
      payment_url
      payment_data
    }
  }
`);

export const SET_CART_FLAGS = minimize_str(`
  mutation ($flags: OrderFlagsInput, $lang:String) {
    result: setCartFlags(flags: $flags, lang: $lang, is_inquiry: 0) ${total_prices}
  }
`);
